import type { PresetShareTarget } from './shareTarget';

/**
 * Shared from gen.ai web: the link is that site's own preset page, as is.
 *
 * Not an Adjust short link. The GenAI generator's link config sends every
 * device into the native app — the App Store on iOS *and* macOS, the `genai://`
 * intent on Android — so a gen.ai share opened the app store for the recipient
 * instead of the page. The preset page serves its own Open Graph tags, so the
 * plain URL unfurls without Adjust's.
 *
 * Portfolio's desktop link (`https://gen.ai/?presetId=…`) does not work here
 * either: gen.ai names a preset by its path, and its home page never opens one
 * from a query param. The origin is the host page's own, so a share from a stage
 * deploy stays on stage. Without a known category there is no page to name, so
 * the link falls back to the site's home rather than guessing one.
 */
const buildGenaiWebShareUrl = ({
  slug,
  category,
}: PresetShareTarget): string => {
  const { origin } = window.location;
  return category
    ? `${origin}/${encodeURIComponent(category)}/${encodeURIComponent(slug)}`
    : `${origin}/`;
};

export default buildGenaiWebShareUrl;
